import {ClassNames} from '../Interfaces/class-names';
import {decodeHtmlText} from '../Helpers/sanitize';

export default class SearchResultCaption {
    public set price(value: string | null) {
        this._price = value;
        if (value === null) {
            this.removeMessage();
        } else if (value === 'unavailable') {
            this.setMessage('This domain is already taken. Please try an alternative option');
        } else {
            const priceElement = Object.assign(document.createElement('strong'), {
                className: this.classNames.searchResultCaptionPrice,
                textContent: decodeHtmlText(this._price),
            });
            this.element.textContent = `${this.base} `;
            this.element.appendChild(priceElement);
            this.element.classList.add(this.classNames.searchResultCaptionActive);
        }
    }

    public readonly element: HTMLRsHeaderElement;
    private _price: string;
    private readonly base = 'You can get this domain now for';
    private classNames: ClassNames;

    public constructor({
                           element,
                           classNames
                       }: {
        element: HTMLRsHeaderElement;
        classNames: ClassNames
    }) {
        this.element = element;
        this.classNames = classNames;
    }

    public setMessage(message: string): this {
        this.element.textContent = message;
        this.element.classList.add(this.classNames.searchResultCaptionActive);
        return this;
    }

    public removeMessage(): this {
        this.element.textContent = '';
        this.element.classList.remove(this.classNames.searchResultCaptionActive);
        return this;
    }
}
